export enum PromotionPaymentMethodEnum {
  CARD = 'CARD',
  QR_PROMPT_PAY = 'QR_PROMPT_PAY',
  DOLFIN_WALLET = 'DOLFIN_WALLET',
  TRUE_MONEY_WALLET = 'TRUE_MONEY_WALLET',
  SHOPEE_PAY = 'SHOPEE_PAY',
  IN_APP_PURCHASE = 'IN_APP_PURCHASE',
}
